import { useEffect, useMemo, useState } from "react";
import useEvent from "react-use-event-hook";
import { useRecoilValue } from "recoil";

import { useTableColumnsDynamic } from "@ryde/controls";
import {
  useInitViewsAndFilters,
  usePageContext,
  usePageTitle,
} from "@ryde/redux";
import {
  bulkOperationsDrawerAF,
  bulkUpdateFormDrawerAF,
  selectedTableRowsIdsAtomFamily,
  tableSettingsDrawerAF,
  topCalendarDatesAtomFamily,
} from "@ryde/shared";

export const useNotificationsPage = () => {
  const { entity } = usePageContext();
  const [isPageReady, setIsPageReady] = useState(false);

  const tableSettingsDrawerOpened = useRecoilValue(
    tableSettingsDrawerAF(entity),
  );
  const bulkOperationsDrawerOpened = useRecoilValue(
    bulkOperationsDrawerAF(entity),
  );
  const selectedIds = useRecoilValue(selectedTableRowsIdsAtomFamily(entity));
  const bulkUpdateFormDrawerOpened = useRecoilValue(
    bulkUpdateFormDrawerAF(entity),
  );
  const calendarDates = useRecoilValue(topCalendarDatesAtomFamily(entity));
  const { tableDefsGeneric } = useTableColumnsDynamic();
  const { pageTitleTranslated } = usePageTitle();

  const { fetchTableRows } = useInitViewsAndFilters({
    entity,
    onInitialized: () => setIsPageReady(true),
    onInitSkipped: () => setIsPageReady(false),
  });

  const onFiltersApply = useEvent((): void => {
    fetchTableRows();
  });

  const notificationHeaderContextValue = useMemo(() => {
    return {
      onFiltersApply,
      onFiltersClear: onFiltersApply,
      onSearchApply: onFiltersApply,
    };
  }, [onFiltersApply]);

  useEffect(() => {
    if (!isPageReady || !calendarDates) {
      return;
    }

    fetchTableRows();
  }, [isPageReady, calendarDates, fetchTableRows]);

  return {
    entity,
    pageTitleTranslated,
    tableDefsGeneric,
    tableSettingsDrawerOpened,
    bulkOperationsDrawerOpened,
    bulkUpdateFormDrawerOpened,
    selectedIds,
    notificationHeaderContextValue,
  };
};
